import React from 'react';
import { PostcodeLightBox } from '../../_flux/components/postcode_light_box/postcode_light_box';
import { handleView } from '../handle_view';
import PostcodeStore from '../../_flux/stores/postcode_store';
import { PostcodeLightBoxStore } from '../../_flux/stores/postcode_lightbox_store';
import {
    onChangePostcodeAction,
    postcodeValidAction,
    postcodeInvalidAction,
    setPostcodeSuggestion
} from '../../_flux/actions/postcode_actions';
import { hide, showError, hideError } from '../../_flux/actions/postcode_light_box_actions';
import { hideAction as unlockUi, showAction as lockUi } from '../../_flux/actions/ui_lock_actions';
import {
    validatePostcode,
    showAutoCompletePostcodeSelector as isAutoSuggestionStore
} from '../../validator/PostcodeAutocompleteValidator';
import { setPostcodeV2 } from '../../_flux/helper/requests/set_postcode_v2';
import getTranslatedText from '../../_flux/helper/get_translated_text';

const stores = {
    postcodeState: PostcodeStore,
    postcodeLightBoxState: PostcodeLightBoxStore,
};

const render = ({
    postcodeState,
    postcodeLightBoxState,
}) => (
    <PostcodeLightBox
        visible={postcodeLightBoxState.visible}
        showError={postcodeLightBoxState.showError}
        postcode={postcodeState.appliedPostcode}
        postcodeInvalid={postcodeState.invalid}
        postcodeInvalidMessage={postcodeState.invalidMessage}
        selectPostcodeSuggestion={setPostcodeSuggestion}
        onChange={onChange}
        onSubmit={onSubmit}
        onClose={hide}
        store={TYROOLA.globals.store}

    />
);

const onChange = value => {
    const { invalid, postcodeSuggestion, touched } = PostcodeStore.getState();

    onChangePostcodeAction(value);

    if (invalid && validatePostcode(TYROOLA.globals.store, value, postcodeSuggestion, touched)) {
        postcodeValidAction();
    }
};

const onSubmit = e => {
    e.preventDefault();
    const { appliedPostcode: postcode,
        postcodeSuggestion,
        touched } = PostcodeStore.getState();
    const isAutoSuggest = isAutoSuggestionStore(TYROOLA.globals.store);

    if (validatePostcode(TYROOLA.globals.store, postcode, postcodeSuggestion, touched)) {
        storePostcode(postcode);
    } else {
        postcodeInvalidAction(isAutoSuggest && getTranslatedText('postcode-autosuggest-select-from-list'));
    }
};

const storePostcode = postcode => {
    hideError();
    lockUi();
    setPostcodeV2(postcode)
        .then(response => {
            location.reload();
        })
        .catch(function (err) {
            const responseJson = err?.responseJSON;
            postcodeInvalidAction(responseJson?.userMessage);
            showError();
            unlockUi();
        });
};

export const init = (container, options) =>
    handleView(stores, render, options, container);
